
import Vue from 'vue';
/**
- <b>template v-slot:default</b> for the highlighted component 
- <b>template v-slot:tooltips</b> for the content inside tooltips
- To modify tooltips location, modify class <b>.eu-onboardingtips-section .eu-tooltips-container</b> and <b>.eu-tooltips-container:after</b> for the arrow
**/
export default Vue.extend<any, any, any, any>({
  name: 'OnboardingTooltips',
  props: {
    /**
     * Set text in the tooltips
     */
    text: {
      type: String,
      default: ''
    },
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set arrow pointer (top, left, bottom, right, ect)
     */
    arrowPointer: {
      type: String,
      default: 'left'
    },
    /**
     * Set onboard highlight is active
     */
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    arrowClasses() {
      return {
        top: this.arrowPointer === 'top',
        topLeft: this.arrowPointer === 'topLeft',
        topRight: this.arrowPointer === 'topRight',
        bottomLeft: this.arrowPointer === 'bottomLeft',
        bottomRight: this.arrowPointer === 'bottomRight',
        left: this.arrowPointer === 'left',
        right: this.arrowPointer === 'right',
        bottom: this.arrowPointer === 'bottom'
      };
    }
  }
});
